import { render, staticRenderFns } from "./JoinContractForm.vue?vue&type=template&id=35479b8c&scoped=true&"
import script from "./JoinContractForm.vue?vue&type=script&lang=js&"
export * from "./JoinContractForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35479b8c",
  null
  
)

export default component.exports